

import React, { useState, useEffect, useCallback, useRef } from "react";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import { gapi } from "gapi-script";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Modal from "./Modal";
import "./GoogleCalendar.css"; 
import { formatDate } from "../../Utils/helpers/commonhelper";
import DeleteModal from "../DeleteModal";
import { faEnvelope, faUser, faXmark } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// 10th october code edit start
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import google_icon from "../../Utils/assets/img/icons/google_icon.svg";
import { toast } from "sonner";
import { fetchGoogleUserInfo } from "./googleClient";
// import { div } from "framer-motion/client";

// client Id and api key get from google cloude console
const CLIENT_ID =
  "791656083371-20fe92r5aq46otpm37miktc966919gfv.apps.googleusercontent.com";
// const API_KEY = "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";
const SCOPES =
  "https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events";
const ACCESS_TOKEN_KEY = "google_access_token";
const ACCESS_TOKEN_EXPIRY_KEY = "google_access_token_expires_at";

function CalendarComponent({ onLogout,setActiveService } = {}) {
  const [events, setEvents] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    date: "",
    startTime: "",
    endDate: "",
    endTime: "",
  });
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  // 10th october code edit start
  const calendarRef = useRef(null);
  const [showMini, setShowMini] = useState(false);
  const [isShrunk, setIsShrunk] = useState(false);
  const [selectedDate, setSelectedDate] = useState(() => {
    const savedDate = localStorage.getItem("calendar_selected_date");
    return savedDate ? new Date(savedDate) : new Date();
  });

  const [currentView, setCurrentView] = useState(() => {
    return localStorage.getItem("calendar_view") || "dayGridMonth";
  });
    const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);
  const [dayHeaderFormat, setDayHeaderFormat] = useState({
    weekday: 'long',
    day: 'numeric'
  });

  const [isLoading, setIsLoading] = useState(false)
  const initClient = async () => {
  await gapi.client.init({
    clientId: CLIENT_ID,
    scope: SCOPES,
    discoveryDocs: [
      "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
    ],
  });
};
const ensureCalendarReady = () => {
  if (!gapi.client?.calendar?.events) {
    throw new Error("Google Calendar API not ready");
  }
};

  const fetchEvents = useCallback(async () => {
  try {
    ensureCalendarReady();
    setLoadingEvents(true);

    const response = await gapi.client.calendar.events.list({
      calendarId: "primary",
      singleEvents: true,
      orderBy: "startTime",
      maxResults: 2500,
    });

    const googleEvents = (response.result.items || []).map((event) => ({
      id: event.id,
      title: event.summary || "(No title)",
      start: event.start?.dateTime || event.start?.date,
      end: event.end?.dateTime || event.end?.date,
      extendedProps: {
        htmlLink: event.htmlLink,
        description: event.description || "",
      },
    }));

    setEvents(googleEvents);
  } catch (err) {
    console.error("Error fetching events:", err);
  } finally {
    setLoadingEvents(false);
  }
}, []);

  // Store token
  const storeToken = (access_token, expires_in) => {
    try {
      localStorage.setItem(ACCESS_TOKEN_KEY, access_token);
      if (expires_in) {
        const expiresAt = Date.now() + expires_in * 1000;
        localStorage.setItem(ACCESS_TOKEN_EXPIRY_KEY, String(expiresAt));
      }
    } catch (e) {
      console.warn("Could not persist token to localStorage", e);
    }
  };


  const clearStoredToken = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(ACCESS_TOKEN_EXPIRY_KEY);
  };

  // Check persisted token on load
  useEffect(() => {
    gapi.load("client", async () => {
      await initClient();
      const token = localStorage.getItem(ACCESS_TOKEN_KEY);
      const expiry = localStorage.getItem(ACCESS_TOKEN_EXPIRY_KEY);
      if (token) {
        const now = Date.now();
        if (expiry && Number(expiry) < now) {
          clearStoredToken();
          setIsLoggedIn(false);
          return;
        }
        gapi.client.setToken({ access_token: token });
        setIsLoggedIn(true);
        fetchEvents();
      }
    });
  }, [fetchEvents]);

  // Refetch on window focus
  useEffect(() => {
    const onFocus = () => {
      const token = localStorage.getItem(ACCESS_TOKEN_KEY);
      if (token) {
        gapi.client.setToken({ access_token: token });
        fetchEvents();
      }
    };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [fetchEvents]);

  const login = useGoogleLogin({
  scope: SCOPES,
onSuccess: async(tokenResponse) => {
    const { access_token, expires_in } = tokenResponse;
 
    gapi.client.setToken({ access_token });
    localStorage.setItem(ACCESS_TOKEN_KEY, access_token);
 
    if (expires_in) {
      localStorage.setItem(
        ACCESS_TOKEN_EXPIRY_KEY,
        String(Date.now() + expires_in * 1000)
      );
    }
    await fetchGoogleUserInfo(access_token)
    setIsLoggedIn(true);
    fetchEvents();
  },
});

  // Sign out
  const signOut = async () => {
    try {
      const token = localStorage.getItem(ACCESS_TOKEN_KEY);
      if (token) {
        await fetch(`https://oauth2.googleapis.com/revoke?token=${token}`, {
          method: "POST",
          headers: {
            "Content-type": "application/x-www-form-urlencoded",
          },
        });
      }
    } catch (err) {
      console.warn("Error revoking token:", err);
    } finally {
      clearStoredToken();
      gapi.client.setToken({});
      setIsLoggedIn(false);
      setEvents([]);

      onLogout?.();
    }
  };
  // Date click handler
const handleDateClick = (info) => {
    const clickedDate = new Date(info.dateStr);
    const dateOnly = clickedDate.toISOString().split("T")[0];
    // Detect current view type (month, week, or day)
    const viewType = info.view.type;
    let startTime, endTime;
    if (viewType === "dayGridMonth") {
      // Default for Month view → 9:00 to 10:00 AM
      startTime = "09:00";
      endTime = "10:00";
    } else {
      // For Week/Day view, use the actual clicked time
      const timeOnly = clickedDate.toTimeString().slice(0, 5); // "HH:MM"
      const nextHour = new Date(clickedDate.getTime() + 60 * 60 * 1000)
        .toTimeString()
        .slice(0, 5);
      startTime = timeOnly || "09:00";
      endTime = nextHour || "10:00";
    }
    setFormData({
      title: "",
      description: "",
      date: dateOnly,
      startTime,
      endDate: dateOnly,
      endTime,
    });
    isLoggedIn ?  setModalOpen(true)  : toast.warning("You must be logged in to create a new event.")
  };
  const saveEvent = async () => {
  try {
    ensureCalendarReady();
    const startISO = new Date(
      `${formData.date}T${formData.startTime}`
    ).toISOString();
    const endISO = new Date(
      `${formData.endDate}T${formData.endTime}`
    ).toISOString();

    const event = {
      summary: formData.title,
      description: formData.description,
      start: { dateTime: startISO },
      end: { dateTime: endISO },
    };
    if (isEditing && selectedEvent) {
      await gapi.client.calendar.events.patch({
        calendarId: "primary",
        eventId: selectedEvent.id,
        resource: event,
      });
    } else {
      await gapi.client.calendar.events.insert({
        calendarId: "primary",
        resource: event,
      });
    }
    await fetchEvents();
    setModalOpen(false);
    setViewModalOpen(false);
    setIsEditing(false);
  } catch (err) {
    console.error("Error saving event:", err);
  }
};
  // Event click handler
  const handleEventClick = (clickInfo) => {
    const event = clickInfo.event;
    setSelectedEvent({
      id: event.id,
      title: event.title,
      start: event.start,
      end: event.end,
      htmlLink: event.extendedProps.htmlLink || "N/A",
      description: event.extendedProps.description || "No description",
    });
    setViewModalOpen(true);
    clickInfo.jsEvent.preventDefault();
  };
  // Delete event
  const handleDeleteEvent = async () => {
    if (!selectedEvent) return;
    // if (window.confirm("Are you sure you want to delete this event?")) {
    setIsLoading(true)
    try {
      await gapi.client.calendar.events.delete({
        calendarId: "primary",
        eventId: selectedEvent.id,
      });
      await fetchEvents();
      setViewModalOpen(false);
      setShowDeleteModal(false);
      setIsLoading(false)
    } catch (err) {
      console.error("Error deleting event:", err);
      setIsLoading(false)
      toast.error("Could not delete event. Check console.");
    }
    // }
  };
  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  // Edit event
  const handleEditEvent = () => {
    if (!selectedEvent) return;
    const startDate = new Date(selectedEvent.start);
    const endDate = new Date(selectedEvent.end);
    setFormData({
      title: selectedEvent.title,
      description: selectedEvent.description,
      // date: startDate.toISOString().split('T')[0],
      date: formatLocalDate(startDate),
      // endDate: endDate.toISOString().split('T')[0],
      endDate: formatLocalDate(endDate),
      startTime: startDate.toTimeString().substring(0, 5),
      endTime: endDate.toTimeString().substring(0, 5),
    });
    setIsEditing(true);
    setViewModalOpen(false);
    // setModalOpen(true);
    isLoggedIn ?  setModalOpen(true)  : toast.warning("You must be logged in to create a new event.")
  };
  // Handle event drag/drop or resize
  const handleEventDropOrResize = async (changeInfo) => {
    try {
      const ev = changeInfo.event;
      await gapi.client.calendar.events.patch({
        calendarId: "primary",
        eventId: ev.id,
        resource: {
          start: { dateTime: ev.start.toISOString() },
          end: { dateTime: ev.end.toISOString() },
        },
      });
      await fetchEvents();
    } catch (err) {
      console.error("Error updating event:", err);
      toast.error("Could not update event. Check console.");
    }
  };
  const handleViewChange = (view) => {
    if (view === "timeGridDay") {
      setShowMini(true);
      setIsShrunk(true);
    } else {
      setShowMini(false);
      setIsShrunk(false);
    }
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
    const calendarApi = calendarRef.current?.getApi();
    calendarApi?.gotoDate(date);
  };
  const handleDatesSet = (info) => {
    handleViewChange(info.view.type);
    const container = document.querySelector(".calendar-container");
    container?.setAttribute("data-view", info.view.type);
    // Sync selected date when user navigates using prev/next/today buttons
    const currentDate = info.view.currentStart;
    setSelectedDate(new Date(currentDate));
    setCurrentView(info.view.type);
    setSelectedDate(info.view.currentStart);
    // Force resize fix
    setTimeout(() => {
      calendarRef.current?.getApi()?.updateSize();
    }, 100);
    if (info.view.type === "timeGridWeek") {
      setDayHeaderFormat({
        weekday: 'long',
        day: 'numeric',
      });
    } else if (info.view.type === "dayGridMonth") {
      setDayHeaderFormat({
        weekday: 'long'
      });
    }
  };
  const handleHeaderClick = (dateStr) => {
    const calendarApi = calendarRef.current?.getApi();
    if (!calendarApi) return;
    // Change to Day View and go to that date
    calendarApi.changeView("timeGridDay", dateStr);
    // Convert dateStr (string) to Date object
    const selected = new Date(dateStr);
    setSelectedDate(selected);
  };
  React.useEffect(() => {
    // Attach click listener to header cells only after render
    const interval = setInterval(() => {
      document.querySelectorAll(".fc-col-header-cell").forEach((cell) => {
        // prevent duplicate listeners
        if (!cell.dataset.bound) {
          cell.dataset.bound = true;
          cell.addEventListener("click", () => {
            const dateStr = cell.getAttribute("data-date");
            if (dateStr) handleHeaderClick(dateStr);
          });
        }
      });
    }, 500);
    return () => clearInterval(interval);
  }, []);
  // Whenever selectedDate changes
  useEffect(() => {
    localStorage.setItem("calendar_selectedDate", selectedDate.toISOString());
  }, [selectedDate]);
  // Whenever view changes
  useEffect(() => {
    localStorage.setItem("calendar_view", currentView);
  }, [currentView]);
  useEffect(() => {
    const savedDate = localStorage.getItem("calendar_selectedDate");
    const savedView = localStorage.getItem("calendar_view");
    const calendarApi = calendarRef.current?.getApi();
    if (savedDate) {
      const parsedDate = new Date(savedDate);
      setSelectedDate(parsedDate);
      calendarApi?.gotoDate(parsedDate);
    }
    if (savedView) {
      calendarApi?.changeView(savedView);
    }
  }, []);
  const dateObj = selectedDate;
  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const dayOfWeek = weekdays[dateObj.getDay()]; // 0-6 => Sunday-Saturday
  const day = dateObj.getDate(); // 1-31
  const monthName = months[dateObj.getMonth()]; // 0-11
  const year = dateObj.getFullYear(); // 4-digit year
  useEffect(() => {
    // Recalculate layout after mini calendar shows/hides
    const timer = setTimeout(() => {
      calendarRef.current?.getApi()?.updateSize();
    }, 300);
    return () => clearTimeout(timer);
  }, [showMini]);
  return (
    // <div className="calendar-container">
    <div className="calendar-container" style={{
      position: "relative", minHeight: "90vh", background: 'transparent',
      boxShadow: 'none'
    }}>
      {showMini && (
        //  parent div to design upper side dtyling of mini calendar

        <div className="mini-calendar px-3 border border-1 rounded-4">
          <div className="d-flex flex-column align-items-start justify-content-start">
            {/* <p>
            {`Day: ${day}, Month: ${monthName}, Year: ${year}`}
          </p> */}
            <h2
              style={{
                color: "#7a3a5e",
                fontSize: "100px",
                fontWeight: 400,
                marginBottom: "0px",
                marginTop: "0px",
                padding: "0px"
              }}
            >
              {day}
            </h2>
            <p
              style={{
                marginTop: "0px",
                color: "#7a3a5e",
                // fontSize:"100px",
                fontWeight: 400,
                marginBottom: "10px",
                paddingLeft: "5px",
              }}
            >
              {dayOfWeek}, {monthName} {year}
            </p>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => handleDateChange(date)}
              inline
              dayClassName={(date) => {
                const today = new Date();
                if (
                  date.getMonth() < today.getMonth() &&
                  date.getFullYear() === today.getFullYear()
                ) {
                  return "past-date";
                }
                return "";
              }}
            />
          </div>
        </div>
      )}
      <div className="d-flex justify-content-between align-items-start ">
        <div className="modern-border-card d-flex justify-content-center align-items-center">
          <h3
            className="m-0"
            style={{
              fontSize: "22px",
              fontWeight: 200,
            }}
          >
            Calendar
          </h3>
        </div>

        <div className="controls">
          {isLoggedIn && (
             <div className="position-relative" ref={profileMenuRef}>
              <button
                onClick={() => setShowProfileMenu((prev) => !prev)}
                title={localStorage.getItem("user_email") || "Connected Outlook account"}
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: "36px",
                  height: "36px",
                  padding: 0,
                  background: "#0078D4",
                  color: "#fff",
                  border: "none",
                }}
              >
                <FontAwesomeIcon icon={faUser} />
              </button>

              {showProfileMenu && (
                <div
                  className="position-absolute bg-white border rounded shadow-sm"
                  style={{
                    top: "44px",
                    right: 0,
                    minWidth: "260px",
                    zIndex: 1000,
                    padding: "14px",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        width: "40px",
                        height: "40px",
                        background: "#0078D4",
                        color: "#fff",
                        flexShrink: 0,
                      }}
                    >
                      <FontAwesomeIcon icon={faUser} />
                    </div>
                    <div style={{ overflow: "hidden" }}>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: "14px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        { localStorage.getItem("user_name")||"Google Account"}
                      </div>
                      <div
                        className="text-muted d-flex align-items-center gap-1"
                        style={{ fontSize: "12px" }}
                      >
                        <FontAwesomeIcon icon={faEnvelope} />
                        <span
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {localStorage.getItem("user_email") || "No email available"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <hr className="my-2" />
                  <div className="text-muted" style={{ fontSize: "12px" }}>
                    Connected to Google Calendar
                  </div>
                </div>
              )}
            </div>
          )}
           { !isLoggedIn &&
            <button
            onClick={() => setActiveService("")}
          >
           Back
          </button>
          }
          <button
            onClick={() => {
              if (isLoggedIn) {
                signOut();
              } else {
                login();
              }
            }}
          >
            {isLoggedIn ? (
              "Logout"
            ) : (
              <>
               
              <div
                className="d-flex gap-1 align-items-center"
                style={{
                  lineHeight: 1,
                  whiteSpace: "nowrap",
                }}
              >
              
     
                <div
                  // className="border border-1"
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                >
                  <img src={google_icon} height={"100%"} width={"100%"} />
                </div>
                <span>Login with google</span>
              </div>
              </>
            )}
          </button>
          <button
            onClick={() => {
              const token = localStorage.getItem(ACCESS_TOKEN_KEY);
              if (!token) {
                toast.error("No token stored. Sign in first.");
                return;
              }
              gapi.client.setToken({ access_token: token });
              fetchEvents();
            }}
            disabled={!isLoggedIn}
          >
            {loadingEvents ? (
              <span className="loading">Loading Events...</span>
            ) : (
              "Refresh Events"
            )}
          </button>
          <button onClick={() => isLoggedIn ?  setModalOpen(true)  : toast.warning("You must be logged in to create a new event.")} disabled={!isLoggedIn}>
            +Add Event
          </button>
        </div>
      </div>

      <div
        className={`calendar-wrapper ${isShrunk ? "shrink" : ""
          } border border-1 rounded-4`}
      >
        <FullCalendar
          ref={calendarRef}
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          dayHeaderFormat={dayHeaderFormat}
          firstDay={1}
          events={events}
          height="80vh"
          editable={true}
          selectable={true}
          dateClick={handleDateClick}
          eventClick={handleEventClick}
          eventDrop={handleEventDropOrResize}
          eventResize={handleEventDropOrResize}
          allDaySlot={false}
          headerToolbar={{
            right: "prev,today,next",
            left: "title",
            center: "timeGridDay,timeGridWeek,dayGridMonth",
          }}

          viewDidMount={(info) => {
            handleViewChange(info.view.type);
            const container = document.querySelector(".calendar-container");
            container?.setAttribute("data-view", info.view.type);
          }}
          datesSet={handleDatesSet}
          dayMaxEventRows={3}
          moreLinkClick="popover"
          eventTimeFormat={{
            hour: "2-digit",
            minute: "2-digit",
            meridiem: "short",
            hour12: true,
          }}
          eventContent={(arg) => {
            return (
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={arg.event.title}
              >
                {arg.timeText && <b>{arg.timeText} </b>}
                {arg.event.title}
              </div>
            );
          }}
        />
      </div>

      {/* Create/Edit Event Modal */}
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={saveEvent}
        formData={formData}
        setFormData={setFormData}
        isEditing={isEditing}
      />

      {/* View Event Modal */}
      {viewModalOpen && selectedEvent && (
        <div className="modal-overlay">
          <div className="view-modal">
            <div
              className="d-flex justify-content-between align-items-center px-3 pb-2"
            >
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip-top">{selectedEvent.title}</Tooltip>
                }
              >
                <h5
                  // title={selectedEvent?.title}
                  style={{
                    width: "88%",
                    whiteSpace: "nowrap",
                    overflowX: "hidden",
                    textOverflow: "ellipsis",
                    fontSize: "1rem",
                    fontWeight: 600,
                    lineHeight: 1,
                    cursor: "pointer",
                    textTransform: "capitalize",
                  }}
                >
                  {selectedEvent?.title}
                </h5>
              </OverlayTrigger>

              <button
                className="btn-close mb-2"
                style={{
                  fontSize: "10px",
                }}
                onClick={() => setViewModalOpen(false)}
              ></button>
            </div>
            <hr className="p-0 m-0" />
            {/* div for body padding */}
            <div className="px-3">
              <div className="event-details">
                <p
                  className="d-flex "
                  style={{ fontWeight: 500, flexDirection: "column" }}
                >
                  <label className="from-label mb-0">Description:</label>{" "}
                  {selectedEvent.description}
                </p>
                <div className="d-flex gap-4">
                  <p
                    className="d-flex flex-column"
                    style={{ flexDirection: "column" }}
                  >
                    <label className="from-label mb-0">Start:</label>{" "}
                    {new Date(selectedEvent.start).toLocaleString()}
                  </p>
                  <p
                    className="d-flex flex-column"
                    style={{ flexDirection: "column" }}
                  >
                    <label className="from-label mb-0">End:</label>{" "}
                    {new Date(selectedEvent.end).toLocaleString()}
                  </p>
                </div>

                <p
                  className="d-flex flex-column"
                  style={{ flexDirection: "column" }}
                >
                  <label className="from-label mb-0">
                    Google Calendar Link:
                  </label>{" "}
                  <a
                    href={selectedEvent.htmlLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open in Calendar
                  </a>
                </p>
              </div>

              <div className="modal-actions">
                <button
                  className="btn btn-default-outline"
                  onClick={handleEditEvent}
                >
                  Edit Event
                </button>
                <button
                  className="btn btn-default"
                  onClick={() => {
                    setShowDeleteModal(true);
                    setViewModalOpen(false);
                  }}
                >
                  Delete Event
                </button>
                {/* <button className="close-btn" onClick={() => setViewModalOpen(false)}>
                Close
              </button> */}
              </div>
            </div>
          </div>
        </div>
      )}
      {showDeleteModal && (
        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={handleDeleteEvent}
          isLoading={isLoading}
          message={"Confirm deleting this event"}
        />
      )}
    </div>
  );

}
export const GoogleCalendar = ({ onLogout,setActiveService } = {}) => {
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <CalendarComponent onLogout={onLogout} setActiveService={setActiveService} />
    </GoogleOAuthProvider>
  );
};

export default GoogleCalendar;